function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

var dispatchCustomEvent = function dispatchCustomEvent(eventName) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var detail = {
    detail: data
  };
  var event = new CustomEvent(eventName, data ? detail : null);
  document.dispatchEvent(event);
};

window.recentlyViewedIds = [];

/**
 *  @class
 *  @function Quantity
 */
if (!customElements.get('quantity-selector')) {
  class QuantityInput extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('.qty');
      this.step = this.input.getAttribute('step');
      this.changeEvent = new Event('change', {
        bubbles: true
      });
      // Create buttons
      this.subtract = this.querySelector('.minus');
      this.add = this.querySelector('.plus');

      // Add functionality to buttons
      this.subtract.addEventListener('click', () => this.change_quantity(-1 * this.step));
      this.add.addEventListener('click', () => this.change_quantity(1 * this.step));

    }
    connectedCallback() {
      this.classList.add('buttons_added');
    }
    change_quantity(change) {
      // Get current value
      let quantity = Number(this.input.value);

      // Ensure quantity is a valid number
      if (isNaN(quantity)) quantity = 1;

      // Check for min & max
      if (this.input.getAttribute('min') > (quantity + change)) {
        return;
      }
      if (this.input.getAttribute('max')) {
        if (this.input.getAttribute('max') < (quantity + change)) {
          return;
        }
      }
      // Change quantity
      quantity += change;

      // Ensure quantity is always a number
      quantity = Math.max(quantity, 1);

      // Output number
      this.input.value = quantity;

      this.input.dispatchEvent(this.changeEvent);
    }
  }
  customElements.define('quantity-selector', QuantityInput);
}



/**
 *  @class
 *  @function ProductCard
 */
if (!customElements.get('product-card')) {
  class ProductCard extends HTMLElement {
    constructor() {
      super();
      this.swatches = this.querySelector('.product-card-swatches');
      this.image = this.querySelector('.product-featured-image-link .product-primary-image');
      this.secondary = this.querySelector('.product-featured-image-link .product-secondary-image');
      this.quick_add = this.querySelector('.product-card--add-to-cart-button-simple');
    }
    connectedCallback() {
      if (this.swatches) {
        this.enableSwatches();
      }
      if (this.quick_add) {
        this.enableQuickView();
      }
      if (this.secondary) {
        window.addEventListener('load', (event) => {
          lazySizes.loader.unveil(this.secondary);
        });
      }
    }
    enableSwatches() {
      let swatch_list = this.swatches.querySelectorAll('.product-card-swatch'),
        org_srcset = this.image ? this.image.dataset.srcset : '';


      swatch_list.forEach((swatch, index) => {
        window.addEventListener('load', (event) => {
          let image = new Image();
          image.srcset = swatch.dataset.srcset;
          lazySizes.loader.unveil(image);
        });
        swatch.addEventListener('mouseover', () => {

          [].forEach.call(swatch_list, function (el) {
            el.classList.remove('active');
          });
          if (this.image) {
            if (swatch.dataset.srcset) {
              this.image.setAttribute('srcset', swatch.dataset.srcset);
            } else {
              this.image.setAttribute('srcset', org_srcset);
            }
          }

          swatch.classList.add('active');
        });
        swatch.addEventListener('click', function (evt) {
          window.location.href = this.dataset.href;
          evt.preventDefault();
        });
      });
    }
    enableQuickView() {
      this.quick_add.addEventListener('click', this.quickAdd.bind(this));
    }

    quickAdd(evt) {
      evt.preventDefault();
      if (this.quick_add.disabled) {
        return;
      }
      this.quick_add.classList.add('loading');
      this.quick_add.setAttribute('aria-disabled', true);

      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/javascript'
        }
      };

      let formData = new FormData(this.form);

      formData.append('id', this.quick_add.dataset.productId);
      formData.append('quantity', 1);
      formData.append('sections', this.getSectionsToRender().map((section) => section.section));
      formData.append('sections_url', window.location.pathname);

      config.body = formData;

      fetch(`${theme.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            return;
          }
          this.renderContents(response);

          dispatchCustomEvent('cart:item-added', {
            product: response.hasOwnProperty('items') ? response.items[0] : response
          });
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.quick_add.classList.remove('loading');
          this.quick_add.removeAttribute('aria-disabled');
        });

      return false;
    }
    getSectionsToRender() {
      return [{
        id: 'Cart',
        section: 'main-cart',
        selector: '.thb-cart-form'
      },
      {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }];
    }
    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section => {
        if (!document.getElementById(section.id)) {
          return;
        }
        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        if (typeof CartDrawer !== 'undefined') {
          new CartDrawer();
        }
        if (typeof Cart !== 'undefined') {
          new Cart().renderContents(parsedState);
        }
      }));


      if (document.getElementById('Cart-Drawer')) {
        document.getElementById('Cart-Drawer').open();
      }

    }
    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }
  }
  customElements.define('product-card', ProductCard);
}

/**
 *  @class
 *  @function PanelClose
 */
class PanelClose extends HTMLElement {

  constructor() {
    super();
    let cc = document.querySelector('.click-capture');

    // Add functionality to buttons
    this.addEventListener('click', (e) => this.close_panel(e));
    document.addEventListener('keyup', (e) => {
      if (e.code) {
        if (e.code.toUpperCase() === 'ESCAPE') {
          document.querySelectorAll('.side-panel').forEach((panel) => {
            panel.classList.remove('active');
            document.body.classList.remove('open-cc');
          });
        }
      }
    });
    cc.addEventListener('click', (e) => {
      document.body.classList.remove('open-cc');
      if (document.querySelector('.side-panel.active')) {
        document.querySelector('.side-panel.active').classList.remove('active');
      }
    });
  }

  close_panel(e) {
    e.preventDefault();
    let panel = e.target.closest('.side-panel');
    panel.classList.remove('active');
    document.body.classList.remove('open-cc');
  }
}
customElements.define('side-panel-close', PanelClose);

/**
 *  @class
 *  @function CartDrawer
 */
if (!customElements.get('cart-drawer')) {
  class CartDrawer extends HTMLElement {

    constructor() {
      super();
    }
    connectedCallback() {
      let button = document.getElementById('cart-drawer-toggle');

      if (!button) {
        return;
      }
      // Add functionality to buttons
      button.addEventListener('click', (e) => {
        e.preventDefault();
        document.body.classList.add('open-cc');
        this.classList.add('active');
        this.focus();

        dispatchCustomEvent('cart-drawer:open');
      });

      this.debouncedOnChange = debounce((event) => {
        this.onChange(event);
      }, 300);

      document.addEventListener('cart:refresh', (event) => {
        this.refresh();
      });

      this.addEventListener('change', this.debouncedOnChange.bind(this));
      this.removeProductEvent();
    }
    open() {
      document.body.classList.add('open-cc');
      this.classList.add('active');
      dispatchCustomEvent('cart-drawer:open');
    }
    close() {
      document.body.classList.remove('open-cc');
      this.classList.remove('active');
    }
    onChange(event) {
      if (event.target.classList.contains('qty')) {
        this.updateQuantity(event.target.dataset.index, event.target.value);
      }
      this.removeProductEvent();
    }
    removeProductEvent() {
      let removes = this.querySelectorAll('.remove');

      removes.forEach((remove) => {
        remove.addEventListener('click', (event) => {
          this.updateQuantity(event.target.dataset.index, '0');

          event.preventDefault();
        });
      });
    }
    getSectionsToRender() {
      return [{
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }];
    }
    getSectionInnerHTML(html, selector) {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }

    updateQuantity(line, quantity) {
      this.querySelector(`#CartDrawerItem-${line}`).classList.add('thb-loading');
      const body = JSON.stringify({
        line,
        quantity,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname
      });
      dispatchCustomEvent('line-item:change:start', {
        quantity: quantity
      });
      fetch(`${theme.routes.cart_change_url}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': `application/json`
        },
        ...{
          body
        }
      })
        .then((response) => {
          return response.text();
        })
        .then((state) => {
          const parsedState = JSON.parse(state);


          this.getSectionsToRender().forEach((section => {
            const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

            elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);

          }));

          this.removeProductEvent();

          dispatchCustomEvent('line-item:change:end', {
            quantity: quantity,
            cart: parsedState
          });
          if (this.querySelector(`#CartDrawerItem-${line}`).length) {
            this.querySelector(`#CartDrawerItem-${line}`).classList.remove('thb-loading');
          }
        });
    }
    refresh() {
      let sections = 'cart-drawer,cart-bubble';
      fetch(`${window.location.pathname}?sections=${sections}`)
        .then((response) => {
          return response.text();
        })
        .then((state) => {
          const parsedState = JSON.parse(state);

          this.getSectionsToRender().forEach((section => {
            const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

            elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState[section.section], section.selector);
          }));

          this.removeProductEvent();
        });
    }
  }
  customElements.define('cart-drawer', CartDrawer);
}

/**
 *  @class
 *  @function QuickView
 */
if (!customElements.get('quick-view')) {
  class QuickView extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.cc = document.querySelector('.click-capture');
      this.drawer = document.getElementById('Product-Drawer');
      this.body = document.body;

      this.addEventListener('click', this.setupEventListener.bind(this));
      this.cc.addEventListener('click', this.setupCCEventListener.bind(this));

    }
    setupCCEventListener(e) {
      this.body.classList.remove('open-cc');
      this.drawer.classList.remove('active');
      this.drawer.querySelector('#Product-Drawer-Content').innerHTML = '';
    }
    setupEventListener(e) {
      e.preventDefault();
      let productHandle = this.dataset.productHandle,
        href = `${theme.routes.root_url}/products/${productHandle}?view=quick-view`;

      // remove double `/` in case shop might have /en or language in URL
      href = href.replace('//', '/');
      if (!href || !productHandle) {
        return;
      }
      if (this.classList.contains('loading')) {
        return;
      }
      this.classList.add('loading');
      fetch(href, {
        method: 'GET'
      })
        .then((response) => {
          this.classList.remove('loading');
          return response.text();
        })
        .then(text => {
          const sectionInnerHTML = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('#Product-Drawer-Content').innerHTML;

          this.renderQuickview(sectionInnerHTML, href, productHandle);

        });
    }
    renderQuickview(sectionInnerHTML, href, productHandle) {
      if (sectionInnerHTML) {

        this.drawer.querySelector('#Product-Drawer-Content').innerHTML = sectionInnerHTML;

        let js_files = this.drawer.querySelector('#Product-Drawer-Content').querySelectorAll('script');

        if (js_files.length > 0) {
          var head = document.getElementsByTagName('head')[0];
          js_files.forEach((js_file, i) => {
            let script = document.createElement('script');
            script.src = js_file.src;
            head.appendChild(script);
          });
        }

        setTimeout(() => {
          window.dispatchEvent(new Event('resize'));
          if (Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }
          if (window.ProductModel) {
            window.ProductModel.loadShopifyXR();
          }
        }, 300);



        this.body.classList.add('open-cc');
        this.drawer.classList.add('active');
        this.drawer.querySelector('.side-panel-close').focus();

        dispatchCustomEvent('quick-view:open', {
          productUrl: href,
          productHandle: productHandle
        });
      }
    }
  }
  customElements.define('quick-view', QuickView);
}

/**
 *  @class
 *  @function ProductRecommendations
 */
class ProductRecommendations extends HTMLElement {
  constructor() {
    super();

  }
  fetchProducts() {
    fetch(this.dataset.url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }

        this.classList.add('product-recommendations--loaded');
      })
      .catch(e => {
        console.error(e);
      });
  }
  connectedCallback() {
    this.fetchProducts();
  }
}

customElements.define('product-recommendations', ProductRecommendations);

/**
 *  @class
 *  @function SelectWidth
 */
class SelectWidth {
  constructor() {
    let _this = this;
    // resize on initial load
    document.querySelectorAll(".resize-select").forEach(_this.resizeSelect);

    // delegated listener on change
    document.body.addEventListener("change", (e) => {
      if (e.target.matches(".resize-select") && e.target.offsetParent !== null) {
        _this.resizeSelect(e.target);
      }
    });
    window.addEventListener('resize.resize-select', function () {
      document.querySelectorAll(".resize-select").forEach(_this.resizeSelect);
    });
  }

  resizeSelect(sel) {
    let tempOption = document.createElement('option');
    tempOption.textContent = sel.selectedOptions[0].textContent;

    let tempSelect = document.createElement('select');
    tempSelect.style.visibility = "hidden";
    tempSelect.style.position = "fixed";
    tempSelect.appendChild(tempOption);

    sel.after(tempSelect);
    if (tempSelect.clientWidth > 0) {
      sel.style.width = `${+tempSelect.clientWidth + 12}px`;
    }
    tempSelect.remove();
  }
}

/**
 *  @class
 *  @function CollapsibleRow
 */
if (!customElements.get('collapsible-row')) {
  // https://css-tricks.com/how-to-animate-the-details-element/
  class CollapsibleRow extends HTMLElement {
    constructor() {
      super();

      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.content = this.querySelector('.collapsible__content');

      // Store the animation object (so we can cancel it if needed)
      this.animation = null;
      // Store if the element is closing
      this.isClosing = false;
      // Store if the element is expanding
      this.isExpanding = false;
    }
    connectedCallback() {
      this.setListeners();
    }
    setListeners() {
      this.querySelector('summary').addEventListener('click', (e) => this.onClick(e));
    }
    prepareAnimations() {
      let _this = this,
        summary_height = this.querySelector('summary').offsetHeight,
        content_height = this.querySelector('.collapsible__content').offsetHeight,
        initial_height = summary_height,
        final_height = summary_height + content_height;

      this.tl = false;
      this.tl = gsap.timeline({
        reversed: !_this.details.open,
        paused: true,
        inherit: false,
        ease: 'none',
        onStart: function () {
          _this.details.open = true;
          _this.details.style.overflow = 'hidden';
        },
        onReverseComplete: function () {
          _this.details.open = false;
          _this.details.style.overflow = '';
        }
      });

      this.tl
        .fromTo(_this.details, {
          height: function () {
            let h = Math.max(Math.max(initial_height, 0), 24);
            return h;
          },
          clearProps: 'height'
        }, {
          duration: 0.4,
          height: final_height,
          clearProps: 'height'
        });

      if (this.details.open) {
        this.tl.progress(1);
      }
    }
    instantClose() {
      this.tl.timeScale(10).reverse();
    }
    animateClose() {
      this.tl.timeScale(3).reverse();
    }
    animateOpen() {
      this.tl.timeScale(1).play();
    }
    onClick(e) {
      // Stop default behaviour from the browser
      e.preventDefault();
      // Add an overflow on the <details> to avoid content overflowing
      this.details.style.overflow = 'hidden';
      // Check if the element is being closed or is already closed
      if (this.isClosing || !this.details.open) {
        this.open();
        // Check if the element is being openned or is already open
      } else if (this.isExpanding || this.details.open) {
        this.shrink();
      }
    }
    shrink() {
      // Set the element as "being closed"
      this.isClosing = true;

      // Store the current height of the element
      const startHeight = `${this.details.offsetHeight}px`;
      // Calculate the height of the summary
      const endHeight = `${this.summary.offsetHeight}px`;

      // If there is already an animation running
      if (this.animation) {
        // Cancel the current animation
        this.animation.cancel();
      }

      // Start a WAAPI animation
      this.animation = this.details.animate({
        // Set the keyframes from the startHeight to endHeight
        height: [startHeight, endHeight]
      }, {
        duration: 250,
        easing: 'ease'
      });

      // When the animation is complete, call onAnimationFinish()
      this.animation.onfinish = () => this.onAnimationFinish(false);
      // If the animation is cancelled, isClosing variable is set to false
      this.animation.oncancel = () => this.isClosing = false;
    }

    open() {
      // Apply a fixed height on the element
      this.details.style.height = `${this.details.offsetHeight}px`;
      // Force the [open] attribute on the details element
      this.details.open = true;
      // Wait for the next frame to call the expand function
      window.requestAnimationFrame(() => this.expand());
    }

    expand() {
      // Set the element as "being expanding"
      this.isExpanding = true;
      // Get the current fixed height of the element
      const startHeight = `${this.details.offsetHeight}px`;
      // Calculate the open height of the element (summary height + content height)
      const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;

      // If there is already an animation running
      if (this.animation) {
        // Cancel the current animation
        this.animation.cancel();
      }

      // Start a WAAPI animation
      this.animation = this.details.animate({
        // Set the keyframes from the startHeight to endHeight
        height: [startHeight, endHeight]
      }, {
        duration: 400,
        easing: 'ease-out'
      });
      // When the animation is complete, call onAnimationFinish()
      this.animation.onfinish = () => this.onAnimationFinish(true);
      // If the animation is cancelled, isExpanding variable is set to false
      this.animation.oncancel = () => this.isExpanding = false;
    }

    onAnimationFinish(open) {
      // Set the open attribute based on the parameter
      this.details.open = open;
      // Clear the stored animation
      this.animation = null;
      // Reset isClosing & isExpanding
      this.isClosing = false;
      this.isExpanding = false;
      // Remove the overflow hidden and the fixed height
      this.details.style.height = this.details.style.overflow = '';
    }
  }
  customElements.define('collapsible-row', CollapsibleRow);
}

/**
 *  @function addIdToRecentlyViewed
 */
function addIdToRecentlyViewed(handle) {

  if (!handle) {
    let product = document.querySelector('.thb-product-detail');

    if (product) {
      handle = product.dataset.handle;
    }
  }
  if (!handle) {
    return;
  }
  if (window.localStorage) {
    let recentIds = window.localStorage.getItem('recently-viewed');
    if (recentIds != 'undefined' && recentIds != null) {
      window.recentlyViewedIds = JSON.parse(recentIds);
    }
  }
  // Remove current product if already in recently viewed array
  var i = window.recentlyViewedIds.indexOf(handle);

  if (i > -1) {
    window.recentlyViewedIds.splice(i, 1);
  }

  // Add id to array
  window.recentlyViewedIds.unshift(handle);

  if (window.localStorage) {
    window.localStorage.setItem('recently-viewed', JSON.stringify(window.recentlyViewedIds));
  }
}

document.addEventListener('DOMContentLoaded', () => {
  if (typeof SelectWidth !== 'undefined') {
    new SelectWidth();
  }
  if (typeof CartDrawer !== 'undefined') {
    new CartDrawer();
  }

});
/* =====================================================================
 * PF — Garde "Stock K.O" niveau panier (2026-06-21)
 * ---------------------------------------------------------------------
 * Bloque l'ajout au panier de toute variante REELLEMENT en rupture, sur
 * TOUTES les surfaces (formulaire produit ET pop-ups Selleasy / quick-add),
 * en contournant inventory_policy=continue : on n'utilise JAMAIS
 * variant.available (faussee a true par la politique "continue"). On lit
 * la verite Liquid — la classe `sold-out` du bouton [name="add"] re-rendu
 * en session courante — exactement comme le fix de assets/product.js
 * (renderProductInfo). On herite donc automatiquement de la verite B2B /
 * dropship (back-order autorise => pas de classe sold-out => ajout permis).
 * Fail-open : la moindre incertitude (URL produit introuvable, fetch KO)
 * => on laisse passer + console.warn. On ne bloque jamais une variante
 * vendable par erreur.
 * =================================================================== */
(function () {
  'use strict';
  if (window.__pfCartGuardInstalled) return;
  window.__pfCartGuardInstalled = true;

  var MESSAGE = 'Stock K.O';
  var nativeFetch = window.fetch ? window.fetch.bind(window) : null;
  // id -> true (rupture) | false (ok) | Promise (verif en cours)
  var cache = Object.create(null);

  /* ---- 1. Reconnaitre une requete d'ajout au panier ---------------- */
  function getAddPath() {
    try { if (window.theme && theme.routes && theme.routes.cart_add_url) return theme.routes.cart_add_url; } catch (e) {}
    try { if (window.routes && window.routes.cart_add_url) return window.routes.cart_add_url; } catch (e) {}
    return '/cart/add';
  }
  function toPath(url) {
    try { return new URL(url, window.location.origin).pathname; } catch (e) { return String(url || ''); }
  }
  function isCartAdd(url) {
    if (!url) return false;
    var path = toPath(url).replace(/\.js$/, '');
    var ref = toPath(getAddPath()).replace(/\.js$/, '');
    return path === ref || /\/cart\/add$/.test(path);
  }

  /* ---- 2. Extraire les variant ids d'un corps de requete ----------- */
  function pushObjIds(obj, out) {
    if (!obj || typeof obj !== 'object') return;
    if (Array.isArray(obj.items)) {
      obj.items.forEach(function (it) { if (it && it.id != null) out.push(String(it.id)); });
    } else if (obj.id != null) {
      out.push(String(obj.id));
    }
  }
  function pushSpIds(sp, out) {
    sp.forEach(function (val, key) {
      if (key === 'id' || /^items\[\d+\]\[id\]$/.test(key)) out.push(String(val));
    });
  }
  function parseIds(body) {
    var out = [];
    try {
      if (body == null) return out;
      if (typeof body === 'string') {
        var s = body.trim();
        if (s.charAt(0) === '{' || s.charAt(0) === '[') { pushObjIds(JSON.parse(s), out); }
        else { pushSpIds(new URLSearchParams(s), out); }
      } else if (typeof FormData !== 'undefined' && body instanceof FormData) {
        var sp = new URLSearchParams();
        body.forEach(function (v, k) { sp.append(k, typeof v === 'string' ? v : ''); });
        pushSpIds(sp, out);
      } else if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) {
        pushSpIds(body, out);
      } else if (typeof body === 'object') {
        pushObjIds(body, out);
      }
    } catch (e) {}
    return out.filter(function (v, i) { return v && v !== 'undefined' && out.indexOf(v) === i; });
  }

  /* ---- 3. Suivre le dernier element declencheur (contexte pop-up) -- */
  var lastTrigger = null;
  ['pointerdown', 'mousedown', 'click'].forEach(function (ev) {
    document.addEventListener(ev, function (e) { lastTrigger = e.target; }, true);
  });

  /* ---- 4. Resoudre l'URL produit (+ section si fiche produit) ------ */
  function productLinkNear(el) {
    var node = el;
    while (node && node.nodeType === 1) {
      if (node.matches && node.matches('a[href*="/products/"]')) return toPath(node.getAttribute('href'));
      var a = node.querySelector && node.querySelector('a[href*="/products/"]');
      if (a) return toPath(a.getAttribute('href'));
      node = node.parentElement;
    }
    return null;
  }
  function resolveContext(id, trigger) {
    // a) Fiche produit : input id cache -> product-form -> variant-selects (data-url/data-section)
    var input = document.querySelector('input[name="id"][value="' + id + '"]');
    if (input) {
      // NB: ne JAMAIS lire `.id` sur un <form> contenant <input name="id"> : la
      // propriete renvoie alors le champ (named control), pas l'attribut id.
      // On passe par le selecteur d'attribut + getAttribute.
      var formEl = input.closest('[id^="product-form-"]');
      var section = formEl ? String(formEl.getAttribute('id')).slice('product-form-'.length) : null;
      var vs = section ? document.querySelector('[data-section="' + section + '"][data-url]') : null;
      if (!vs) vs = document.querySelector('variant-selects[data-url], variant-radios[data-url], [data-section][data-url]');
      if (vs) {
        var url = vs.getAttribute('data-url');
        if (!section) section = vs.getAttribute('data-section');
        if (url) return { url: url, section: section };
      }
    }
    // b) Pop-up / quick-add : lien /products/ le plus proche du declencheur
    if (trigger) {
      var link = productLinkNear(trigger);
      if (link) return { url: link, section: null };
    }
    // c) Dernier recours : lien produit dans un eventuel modal ouvert
    var modal = document.querySelector('[id*="selleasy" i], [class*="selleasy" i], [class*="upsell" i], [role="dialog"], .modal');
    var ml = modal && modal.querySelector ? modal.querySelector('a[href*="/products/"]') : null;
    if (ml) return { url: toPath(ml.getAttribute('href')), section: null };
    return null;
  }

  /* ---- 5. Verifier la rupture reelle via la verite Liquid ---------- */
  function checkSoldOut(id, trigger) {
    var cached = cache[id];
    if (cached === true || cached === false) return Promise.resolve(cached);
    if (cached && typeof cached.then === 'function') return cached;

    var ctx = resolveContext(id, trigger);
    if (!ctx || !ctx.url) {
      console.warn('[PF cart-guard] URL produit introuvable pour la variante ' + id + ' -> ajout autorise (fail-open).');
      return Promise.resolve(false);
    }
    if (!nativeFetch) return Promise.resolve(false);

    var u = ctx.url + (ctx.url.indexOf('?') === -1 ? '?' : '&') + 'variant=' + encodeURIComponent(id);
    if (ctx.section) u += '&section_id=' + encodeURIComponent(ctx.section);

    var p = nativeFetch(u, { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (htmlText) {
        var doc = new DOMParser().parseFromString(htmlText, 'text/html');
        var addBtn = doc.querySelector('[name="add"]');
        var soldOut = addBtn ? addBtn.classList.contains('sold-out') : false; // pas de bouton => on ne bloque pas
        cache[id] = soldOut;
        return soldOut;
      })
      .catch(function (e) {
        console.warn('[PF cart-guard] verification stock impossible pour ' + id + ' -> fail-open.', e);
        delete cache[id];
        return false;
      });
    cache[id] = p;
    return p;
  }
  function anySoldOut(ids, trigger) {
    try {
      if (!ids || !ids.length) return Promise.resolve(false);
      return Promise.all(ids.map(function (id) {
        try { return checkSoldOut(id, trigger); }
        catch (e) { console.warn('[PF cart-guard] check KO ' + id + ' -> fail-open.', e); return Promise.resolve(false); }
      })).then(function (res) { return res.indexOf(true) !== -1; })
        .catch(function () { return false; });
    } catch (e) {
      console.warn('[PF cart-guard] anySoldOut KO -> fail-open.', e);
      return Promise.resolve(false);
    }
  }

  /* ---- 6. UX de blocage : toast + reponse 422 compatible theme ----- */
  function showToast(msg) {
    try {
      var t = document.createElement('div');
      t.className = 'pf-stock-ko-toast';
      t.setAttribute('role', 'alert');
      t.textContent = msg;
      t.style.cssText = 'position:fixed;z-index:2147483647;left:50%;top:24px;transform:translateX(-50%);' +
        'background:#E51D1D;color:#fff;padding:12px 22px;border-radius:4px;font-weight:700;font-size:14px;' +
        'letter-spacing:.02em;box-shadow:0 4px 14px rgba(0,0,0,.25);max-width:90%;text-align:center;';
      (document.body || document.documentElement).appendChild(t);
      setTimeout(function () { if (t.parentNode) t.parentNode.removeChild(t); }, 3500);
    } catch (e) {}
  }
  function blockedResponse() {
    // Format d'erreur Shopify /cart/add -> le formulaire produit du theme
    // affiche nativement `description` ("Stock K.O") pres du bouton.
    var payload = JSON.stringify({ status: 422, message: MESSAGE, description: MESSAGE });
    return new Response(payload, {
      status: 422,
      statusText: 'Unprocessable Entity',
      headers: { 'Content-Type': 'application/json' }
    });
  }

  /* ---- 7. Interception window.fetch -------------------------------- */
  if (nativeFetch) {
    window.fetch = function (input, init) {
      try {
        var url = (typeof input === 'string') ? input : (input && input.url);
        var method = (init && init.method) || (input && input.method) || 'GET';
        if (isCartAdd(url) && String(method).toUpperCase() === 'POST') {
          var self = this;
          var bodyP;
          if (init && init.body != null) bodyP = Promise.resolve(init.body);
          else if (input && typeof input.clone === 'function') {
            try { bodyP = input.clone().text(); } catch (e) { bodyP = Promise.resolve(null); }
          } else bodyP = Promise.resolve(null);
          var trigger = lastTrigger;
          return bodyP.then(function (body) {
            return anySoldOut(parseIds(body), trigger);
          }).then(function (blocked) {
            if (blocked) { showToast(MESSAGE); return blockedResponse(); }
            return nativeFetch.call(self, input, init);
          }).catch(function () {
            return nativeFetch.call(window, input, init); // fail-open
          });
        }
      } catch (e) { /* fail-open ci-dessous */ }
      return nativeFetch.apply(this, arguments);
    };
  }

  /* ---- 8. Interception XMLHttpRequest ------------------------------ */
  var XHR = window.XMLHttpRequest;
  if (XHR && XHR.prototype) {
    var origOpen = XHR.prototype.open;
    var origSend = XHR.prototype.send;
    XHR.prototype.open = function (method, url) {
      try {
        this.__pfIsAdd = String(method || '').toUpperCase() === 'POST' && isCartAdd(url);
        this.__pfTrigger = lastTrigger;
      } catch (e) { this.__pfIsAdd = false; }
      return origOpen.apply(this, arguments);
    };
    XHR.prototype.send = function (body) {
      var xhr = this;
      if (!xhr.__pfIsAdd) return origSend.apply(xhr, arguments);
      var p;
      try { p = anySoldOut(parseIds(body), xhr.__pfTrigger); }
      catch (e) { return origSend.call(xhr, body); } // fail-open
      p.then(function (blocked) {
        if (blocked) {
          showToast(MESSAGE);
          try { xhr.dispatchEvent(new Event('error')); } catch (e) {}
          try { xhr.dispatchEvent(new Event('loadend')); } catch (e) {}
          // requete /cart/add NON envoyee
        } else {
          origSend.call(xhr, body);
        }
      }).catch(function () {
        origSend.call(xhr, body); // fail-open
      });
    };
  }
})();

